/* eslint-disable no-unused-vars */
import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import Modal from "@shared/v2/Modal";
import Button from "@shared/v2/Button";
import { ArrowRightSolidV6 } from "@shared/v2/Icomoon";
import SaveSmartFilterFields from "./SaveSmartFilterFields";
import MultipleSaveSmartFilterFields from "./MultipleSaveSmartFilterFields";

const CreateMailerCampaignModal = ({ show, onHide, onNext, defaultFilterName, matchCount, matches }) => {
  const [filterName, setFilterName] = useState(defaultFilterName);
  const [selectedFilterId, setSelectedFilterId] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);

  useEffect(() => {
    if (show) {
      setFilterName(defaultFilterName);
      setSelectedFilterId(null);
      setIsSubmitting(false);
    }
  }, [show, defaultFilterName, matchCount]);

  const handleNext = async () => {
    if (isSubmitting) return;

    let nextValue;
    if (matchCount === 0) {
      nextValue = filterName.trim();
      if (!nextValue) return;
    } else {
      nextValue = matches.find((filter) => String(filter.id) === String(selectedFilterId));
      if (!nextValue) return;
    }

    setIsSubmitting(true);
    try {
      await onNext(nextValue);
    } catch (_error) {
      return;
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      dialogClassName="tw-flex tw-items-center tw-justify-center tw-min-h-full tw-max-h-full"
      contentClassName="tw-w-[600px] tw-space-y-[32px] tw-m-auto"
    >
      <Modal.Header title="Create Mailer Campaign" closeButton />
      <Modal.Body className="tw-space-y-[24px]">
        <p className="tw-m-0 tw-text-14d tw-leading-[20px] tw-text-gray-75">
          Campaigns created from Brivity that contain more than 50 contacts must be connected to a Smart
          Filter.
        </p>
        {matchCount === 0 ? (
          <SaveSmartFilterFields filterName={filterName} onFilterNameChange={setFilterName} />
        ) : (
          <MultipleSaveSmartFilterFields
            filters={matches}
            selectedFilterId={selectedFilterId}
            onSelectFilter={setSelectedFilterId}
          />
        )}
      </Modal.Body>
      <Modal.Footer className="tw-flex tw-justify-between">
        <Button schema="tertiary" size="medium" onClick={onHide}>
          Cancel
        </Button>
        <Button
          schema="primary"
          size="medium"
          onClick={handleNext}
          disabled={matchCount === 0 ? !filterName.trim() : selectedFilterId == null}
          isLoading={isSubmitting}
        >
          <span className="tw-inline-flex tw-items-center tw-gap-[6px]">
            Next
            <ArrowRightSolidV6 className="tw-h-[12px] tw-w-[12px]" />
          </span>
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

CreateMailerCampaignModal.propTypes = {
  show: PropTypes.bool,
  onHide: PropTypes.func,
  onNext: PropTypes.func,
  defaultFilterName: PropTypes.string,
  matchCount: PropTypes.number,
  matches: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
    }),
  ),
};

CreateMailerCampaignModal.defaultProps = {
  show: false,
  onHide: () => {},
  onNext: () => {},
  defaultFilterName: "",
  matchCount: 0,
  matches: [],
};

export default CreateMailerCampaignModal;
